export default __webpack_public_path__ + "static/project-slide-5-992-765-556dcc9969c2f88378e28724f0beeaae.webp";